import { render, staticRenderFns } from "./PrkAddCourseEffectModal.vue?vue&type=template&id=31589908&scoped=true&"
import script from "./PrkAddCourseEffectModal.vue?vue&type=script&lang=js&"
export * from "./PrkAddCourseEffectModal.vue?vue&type=script&lang=js&"
import style0 from "./PrkAddCourseEffectModal.vue?vue&type=style&index=0&id=31589908&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31589908",
  null
  
)

export default component.exports